import React, { useState, useEffect } from 'react';  // Import useState and useEffect
import ReactDOM from 'react-dom/client';
import './index.css';
import { router } from "./routes"
import { RouterProvider } from "react-router-dom";
import 'normalize.css';
import '@/global.css'
import 'swiper/css';
import Global from './components/global';
import Hls from 'hls.js';
import { Helmet } from "react-helmet";
import u from './util';
import { REACT_APP_STATIC_JS_ONE, REACT_APP_STATIC_JS_TWO, REACT_APP_STATIC_JS_THREE, REACT_APP_STATIC_JS_FOUR } from './const/prod.const';
// import u from './util';

const w = window as any
w.Hls = Hls;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if(!localStorage.getItem('test_mode')){
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
  }
}

declare const window: any;

// added to window variables
let mmList = window.mmList;
let goodsList = window.goodsList;
let qixia = window.qixia;
let lboxayerList = window.lboxayerList;
// 强制删除磁盘缓存中的旧缓存数据

const APP_VERSION = "1.0.0"; // 每次更新时修改
if(localStorage.getItem("__APP_VERSION") !== APP_VERSION){
  localStorage.clear();
  localStorage.setItem("__APP_VERSION", APP_VERSION);
}

if ('caches' in window) {
  caches.keys().then(keys => {
    keys.forEach(key => caches.delete(key));
  });
}

// 强制删除旧 Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}

(function(){
  var keys = Object.keys(window).join();

  setInterval(function(){
    var newKeys = Object.keys(window).join();

    // detect new added window variables
    if (newKeys !== keys) {
      // console.log('`window` changd', newKeys);
      if(newKeys.includes("mmList")){
        localStorage.setItem("__MM", JSON.stringify(window.mmList));
      }
      if(newKeys.includes("goodsList")){
        localStorage.setItem("__GD", JSON.stringify(window.goodsList));
      }
      if(newKeys.includes("qixia")){
        localStorage.setItem("__QX", JSON.stringify(window.qixia));
      }
      if(newKeys.includes("lboxayerList")){
        localStorage.setItem("__BXL", JSON.stringify(window.lboxayerList));
      }
      keys = newKeys;
    }
  }, 100);

})();

// Main App component to manage Global loading state
const App = () => {
  const [globalLoaded, setGlobalLoaded] = useState(false);
  const [encryptedJsOne, setEncryptedJsOne] = useState<string | null>(null);
  const [encryptedJsTwo, setEncryptedJsTwo] = useState<string | null>(null);
  const [encryptedJsThree, setEncryptedJsThree] = useState<string | null>(null);
  const [encryptedJsFour, setEncryptedJsFour] = useState<string | null>(null);
  const [Material, setMaterial] = useState<any>()
  const [error, setError] = useState<string | null>(null);   // Store error if any


  // Callback for when Global component finishes loading
  const handleGlobalLoad = () => {
    setGlobalLoaded(true);
  };

  useEffect(() => {
    const doEncrypt = async (envUrl?: string | null) => {
      if (!envUrl) return null;
      try {
        const urlObj = new URL(envUrl);
        const origin = urlObj.origin + '/';
        const pathToEncrypt = urlObj.pathname;
        let packed = null;
        if(pathToEncrypt.includes('/data')){
          packed = await u.b64EncryptURI(pathToEncrypt);
        }else{
          packed = await u.encryptAesCbc256B64(pathToEncrypt);
        }

        console.log("doEncrypt", origin + packed , "original ", pathToEncrypt);
        return origin + packed;
      } catch {
        return null;
      }
    };

    (async () => {
      const [one, two, three, four] = await Promise.all([
        doEncrypt(REACT_APP_STATIC_JS_ONE),
        doEncrypt(REACT_APP_STATIC_JS_TWO),
        doEncrypt(REACT_APP_STATIC_JS_THREE),
        doEncrypt(REACT_APP_STATIC_JS_FOUR),
      ]);
      setEncryptedJsOne(one);
      setEncryptedJsTwo(two);
      setEncryptedJsThree(three);
      setEncryptedJsFour(four);
    })();
  }, []);

  useEffect(() => {
    if (!encryptedJsTwo) return; // wait until encrypted URL is ready
    const fetchMaterial = async () => {
      try {
        const result = await u.getMaterial(encryptedJsTwo);
        // console.log("fetchMaterial", result);
        // Mirror old script-tag behavior: set window.qixia (var) and persist JSON
        try {
          let stored = false;
          if (typeof result === 'object' && result) {
            (window as any).qixia = result;
            localStorage.setItem("__QX", JSON.stringify(result));
            stored = true;
          } else if (typeof result === 'string') {
            // 1) Try to extract `var qixia = {...};`
            const match = result.match(/var\s+qixia\s*=\s*(\{[\s\S]*?\})\s*;?/);
            if (match && match[1]) {
              const jsonText = match[1]
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');
              try {
                const obj = JSON.parse(jsonText);
                ;(window as any).qixia = obj;
                localStorage.setItem("__QX", JSON.stringify(obj));
                stored = true;
              } catch {}
            }
            // 2) If still not stored, execute the script text to populate window.qixia
            if (!stored) {
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.text = result;
              document.body.appendChild(script);
              try {
                const qx = (window as any).qixia;
                if (qx && typeof qx === 'object') {
                  localStorage.setItem("__QX", JSON.stringify(qx));
                  stored = true;
                }
              } finally {
                document.body.removeChild(script);
              }
            }
          }
          // 3) Ensure __QX is at least an empty object if not stored yet
          if (!stored && !localStorage.getItem("__QX")) {
            localStorage.setItem("__QX", "{}");
          }
        } catch {}
      } catch (err) {
        setError('Failed to fetch materials from encrypted REACT_APP_STATIC_JS_TWO');
      }
    };
    fetchMaterial();
  }, [encryptedJsTwo])

  // Encrypted fetch for JS_ONE -> expect window.mmList, store __MM
  useEffect(() => {
    if (!encryptedJsOne) return;
    const fetchOne = async () => {
      try {
        const result = await u.getMaterial(encryptedJsOne);
        try { 
          let stored = false;
          if (typeof result === 'object' && result) {
            (window as any).mmList = result;
            localStorage.setItem("__MM", JSON.stringify(result));
            stored = true;
          } else if (typeof result === 'string') {
            const match = result.match(/var\s+mmList\s*=\s*(\[[\s\S]*?\]|\{[\s\S]*?\})\s*;?/);
            if (match && match[1]) {
              const jsonText = match[1]
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');
              try {
                const obj = JSON.parse(jsonText);
                ;(window as any).mmList = obj;
                localStorage.setItem("__MM", JSON.stringify(obj));
                stored = true;
              } catch {}
            }
            if (!stored) {
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.text = result;
              document.body.appendChild(script);
              try {
                const mm = (window as any).mmList;
                if (mm && (typeof mm === 'object' || Array.isArray(mm))) {
                  localStorage.setItem("__MM", JSON.stringify(mm));
                  stored = true;
                }
              } finally {
                document.body.removeChild(script);
              }
            }
          }
          if (!stored && !localStorage.getItem("__MM")) {
            localStorage.setItem("__MM", "[]");
          }
        } catch {}
      } catch {}
    };
    fetchOne();
  }, [encryptedJsOne])

  // Encrypted fetch for JS_THREE -> expect window.qixia, store __QX (same handling as JS_TWO)
  useEffect(() => {
    if (!encryptedJsThree) return;
    const fetchThree = async () => {
      try {
        const result = await u.getMaterial(encryptedJsThree);
        try {
          let stored = false;
          if (typeof result === 'object' && result) {
            (window as any).qixia = result;
            localStorage.setItem("__QX", JSON.stringify(result));
            stored = true;
          } else if (typeof result === 'string') {
            const match = result.match(/var\s+qixia\s*=\s*(\{[\s\S]*?\})\s*;?/);
            if (match && match[1]) {
              const jsonText = match[1]
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');
              try {
                const obj = JSON.parse(jsonText);
                ;(window as any).qixia = obj;
                localStorage.setItem("__QX", JSON.stringify(obj));
                stored = true;
              } catch {}
            }
            if (!stored) {
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.text = result;
              document.body.appendChild(script);
              try {
                const qx = (window as any).qixia;
                if (qx && typeof qx === 'object') {
                  localStorage.setItem("__QX", JSON.stringify(qx));
                  stored = true;
                }
              } finally {
                document.body.removeChild(script);
              }
            }
          }
          if (!stored && !localStorage.getItem("__QX")) {
            localStorage.setItem("__QX", "{}");
          }
        } catch {}
      } catch {}
    };
    fetchThree();
  }, [encryptedJsThree])

  // Encrypted fetch for JS_FOUR -> expect window.goodsList, store __GD
  useEffect(() => {
    if (!encryptedJsFour) return;
    const fetchFour = async () => {
      try {
        const result = await u.getMaterial(encryptedJsFour);
        // console.log('show result', result)
        try {
          let stored = false;
          if (typeof result === 'object' && result) {
            (window as any).goodsList = result;
            localStorage.setItem("__GD", JSON.stringify(result));
            stored = true;
          } else if (typeof result === 'string') {
            const match = result.match(/var\s+goodsList\s*=\s*(\[[\s\S]*?\]|\{[\s\S]*?\})\s*;?/);
            if (match && match[1]) {
              const jsonText = match[1]
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');
              try {
                const obj = JSON.parse(jsonText);
                ;(window as any).goodsList = obj;
                localStorage.setItem("__GD", JSON.stringify(obj));
                stored = true;
              } catch {}
            }
            if (!stored) {
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.text = result;
              document.body.appendChild(script);
              try {
                const gd = (window as any).goodsList;
                if (gd && (typeof gd === 'object' || Array.isArray(gd))) {
                  localStorage.setItem("__GD", JSON.stringify(gd));
                  stored = true;
                }
              } finally {
                document.body.removeChild(script);
              }
            }
          }
          if (!stored && !localStorage.getItem("__GD")) {
            localStorage.setItem("__GD", "[]");
          }
        } catch {}
      } catch {}
    };
    fetchFour();
  }, [encryptedJsFour])
  // useEffect(() => { 
  //   if (!REACT_APP_STATIC_JS_FOUR) return;

  //   const fetchFour = async () => {
  //     try {
  //       const result = await u.getMaterial(REACT_APP_STATIC_JS_FOUR);

  //       try {
  //         let stored = false;

  //         // --- Case 1: already JSON object ---
  //         if (typeof result === 'object' && result) {
  //           const goodsArr = result.goods || result; // ✅ only keep array if inside "goods"
  //           (window as any).goodsList = goodsArr;
  //           localStorage.setItem("__GD", JSON.stringify(goodsArr));
  //           stored = true;

  //         // --- Case 2: result is string ---
  //         } else if (typeof result === 'string') {
  //           const match = result.match(/var\s+goodsList\s*=\s*(\[[\s\S]*?\]|\{[\s\S]*?\})\s*;?/);
  //           if (match && match[1]) {
  //             const jsonText = match[1]
  //               .replace(/,\s*}/g, '}')
  //               .replace(/,\s*]/g, ']');

  //             try {
  //               const parsed = JSON.parse(jsonText);
  //               const goodsArr = parsed.goods || parsed; // ✅ keep only array
  //               (window as any).goodsList = goodsArr;
  //               localStorage.setItem("__GD", JSON.stringify(goodsArr));
  //               stored = true;
  //             } catch {}
  //           }

  //           // --- fallback: execute as script ---
  //           if (!stored) {
  //             const script = document.createElement('script');
  //             script.type = 'text/javascript';
  //             script.text = result;
  //             document.body.appendChild(script);
  //             try {
  //               const gd = (window as any).goodsList;
  //               const goodsArr = gd?.goods || gd; // ✅ only array
  //               if (goodsArr && (typeof goodsArr === 'object' || Array.isArray(goodsArr))) {
  //                 localStorage.setItem("__GD", JSON.stringify(goodsArr));
  //                 stored = true;
  //               }
  //             } finally {
  //               document.body.removeChild(script);
  //             }
  //           }
  //         }

  //         if (!stored && !localStorage.getItem("__GD")) {
  //           localStorage.setItem("__GD", "[]");
  //         }

  //       } catch (err) {
  //         console.error('parse error', err);
  //       }
  //     } catch (err) {
  //       console.error('fetch error', err);
  //     }
  //   };

  //   fetchFour();
  // }, [REACT_APP_STATIC_JS_FOUR]);


  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{window?.location?.host}</title>
        {/* <script async src={u.getAppScriptResources(1)}></script> */}
        {/* {encryptedJsTwo && <script async src={encryptedJsTwo}></script>} */}
        {/* <script async src={u.getAppScriptResources(3)}></script> */}
        {/* <script async src={u.getAppScriptResources(4)}></script> */}
        <script async src={u.getAppScriptResources(5)} data-website-id={u.getAppScriptResources(6)}></script>
      </Helmet>

      {/* Render Global component, pass the onLoad callback */}
      <Global onLoad={handleGlobalLoad} />

      {/* Render RouterProvider only when Global has finished loading */}
      {globalLoaded && (
        <RouterProvider router={router} />
      )}
    </div>
  );
};

// Render the App
root.render(<App />);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();